<div class="tag-container" *ngIf="tagList && tagList.length > 0" (click)="onClick($event)">
    <ng-container *ngFor="let tag of tagList; let i = index">
      <p-chip [rounded]="true" class="flex align-items-center filter-tag">
        <span class="p-chip-text mt-1 mb-1"><bdi>{{ getDisplayLabel(tag) | translateLang |async }}</bdi> </span>
        
        <!-- Search Type Icon for Advanced Thesaurus -->
        <img [src]="getSearchTypeIcon(tag)" 
             [id]="'searchTypeIcon-' + tag.id + (tag.categoryId ? '-' + tag.categoryId : '')"
             [alt]="'iaa.app.advancedSearch.selectSearchType' | translate" 
             class="search-type-icon"
             role="button"
             tabindex="0"
             [attr.aria-label]="'iaa.app.advancedSearch.selectSearchType' | translate"
             (click)="openSearchTypePopup($event, tag)"
             (keydown)="handleSearchTypeIconKeydown($event, tag)"
             [pTooltip]="'iaa.app.advancedSearch.selectSearchType' | translate"
             tooltipPosition="top" />
        
        <i   
          class="pi pi-times mr-2 mt-1 cursor-pointer chip-icon"
          (click)="onRemove($event, tag)"
          (keydown.enter)="onRemove($event, tag)"
          role="button"
          tabindex="0"
          [attr.aria-label]="('iaa.general.removeTag' | translate)+ ' ' + (tag.label | translateLang | async) "          ></i>
      </p-chip>
    </ng-container>

    <!-- Search Type Selection Popup -->
    <app-search-type-selector 
      #searchTypeSelector
      [value]="currentTag?.searchType || 'branch'"
      [uniqueId]="getCurrentTagId()"
      (valueChange)="onSearchTypeChange($event)">
    </app-search-type-selector>
  </div>
